import React, { FC } from 'react';

import { Modal } from 'src/shared/components';

interface FilePreviewModalProps {
  file: File | null;
  open: boolean;
  onClose: () => void;
}

export const FilePreviewModal: FC<FilePreviewModalProps> = ({ file, open, onClose }) => {
  if (!file) {
    return null;
  }

  const fileUrl = URL.createObjectURL(file);
  const isImage = file.type.startsWith('image/');

  return (
    <Modal
      open={open}
      onClose={onClose}
      _container={{
        '& .modal-wrapper': {
          padding: '0px !important',
        },
        '& .modal-wrapper .modal-body': {
          padding: '0px !important',
        },
      }}
      sx={{ minWidth: { lg: '920px' } }}
    >
      {isImage ? (
        <img
          src={fileUrl}
          alt={file.name}
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '90vh',
            objectFit: 'contain',
            display: 'block',
          }}
        />
      ) : (
        <iframe src={fileUrl} width="100%" height="900px" style={{ border: 'none' }} />
      )}
    </Modal>
  );
};
